/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { combineReducers } from 'redux';

import mbpUtil from 'mbp-api-util';
import * as addressBookEntries from './AddressBookEntry/AddressBookEntry-Operations';
import addressBookReducer from './AddressBookEntry/AddressBookEntry-Reducers';
import walletReducer from '../../../Member/ducks/Wallet/Wallet-Reducers';
import enterpriseIdReducer from '../../../Member/ducks/EnterpriseId/EnterpriseId-Reducers';
import profileReducer from '../../../Member/ducks/Profile/Profile-Reducers';
import  watchers from '../../../Member/ducks/Profile/Profile-Operations';
import authReducers, { authWatcherSagas } from '../../../Member/ducks/Auth/index';
import shopRunnerReducer from '../../../Member/ducks/Shoprunner';
import addressBookStandalone from '../../../Member/ducks/AddressBook/AddressBook-Operations';
import walletOperations from '../../../Member/ducks/Wallet/Wallet-Operations';

const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

let memberWatchersSagas = [
    ...addressBookEntries.watchers,
];

if (REACT_APP_INJECTABLE === 'false') {
    memberWatchersSagas = [
        ...addressBookEntries.watchers,
        ...authWatcherSagas,
        ...watchers.watchers,
        ...addressBookStandalone.watchers,
        ...walletOperations.watchers,
    ];
}

// Reducer
let memberReducers = combineReducers({
    addressBook: addressBookReducer,
});

if (REACT_APP_INJECTABLE === 'false') {
    memberReducers = combineReducers({
        addressBook: addressBookReducer,
        wallet: walletReducer,
        enterpriseId: enterpriseIdReducer,
        profile: profileReducer,
        auth: authReducers,
        shopRunner: shopRunnerReducer,
    });
}

export {
    memberWatchersSagas,
};

export default memberReducers;
